import JourneyInfoSide from './styled';

export default JourneyInfoSide;
